import { Component, ViewEncapsulation, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { LanguagesService, Language } from '@shared/services/languages/languages.service';

import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FlagComponent } from '@shared/components/flag/flag.component';
import { Platform } from '@angular/cdk/platform';
import { MetadataService } from 'app/shared/services/meta-data-service/meta-data.service';
@Component({
  selector: 'language-menu',
  standalone: true,
  imports: [
    MatMenuModule,
    MatButtonModule,
    FlagComponent
],
  templateUrl: './language-menu.component.html',
  styleUrls: ['./language-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageMenuComponent {
  languages = computed(() => {
    return this.languagesService.getLanguages().map(l => {
      const altLang = this.metaDataService.alternateLangs().find(al => al.lang === l.code);
      return {
        flag: l.code.replace('en', 'us'),
        url: `/${l.code}${altLang ? (altLang.path ? altLang.path:  altLang?.basePath)  :'/online-fair'}`,
        name: l.name
      }
    });
  });

  selectedLanguage: Language;
  metaDataService = inject(MetadataService);
  constructor(
    private languagesService: LanguagesService,
    public platform: Platform,
  ) {
    this.selectedLanguage = languagesService.getCurrentLang();
  }
}
